export function visitorLeadSeries(visitorMonths, leadMonths) {
  const visitors = Array.isArray(visitorMonths) ? visitorMonths : [];
  const leads = Array.isArray(leadMonths) ? leadMonths : [];
  const visitorCount = new Map();
  const leadMonth = new Map();
  const keys = [];
  for (const month of visitors) {
    if (!month?.key || visitorCount.has(month.key)) continue;
    visitorCount.set(month.key, Number(month.count) || 0);
    keys.push(month.key);
  }
  for (const month of leads) {
    if (!month?.key || leadMonth.has(month.key)) continue;
    leadMonth.set(month.key, month);
    if (!visitorCount.has(month.key)) keys.push(month.key);
  }
  return keys.map((key) => {
    const lead = leadMonth.get(key);
    const visitor = visitors.find((month) => month?.key === key);
    return {
      key,
      label: lead?.label || visitor?.label || key,
      visitors: visitorCount.has(key) ? visitorCount.get(key) : 0,
      count: Number(lead?.count) || 0,
      leads: Array.isArray(lead?.leads) ? lead.leads : [],
    };
  });
}
